
// This is an auto generated file - do not edit!
// Swagger path: /api/Party/{id}/relatedclients

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    PartyRole
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class PartyIdRelatedclientsApiService extends BaseApiService {
    
    get(id: string, includeSingularRoles?: boolean, accountHoldersOnly?: boolean, options = {}): Observable<PartyRole[]> {
        let params = new HttpParams();
        if(includeSingularRoles !== undefined) {
            params = params.append('includeSingularRoles', includeSingularRoles);
        }
        if(accountHoldersOnly !== undefined) {
            params = params.append('accountHoldersOnly', accountHoldersOnly);
        }

        return this._get<PartyRole[]>(
            `/Party/${id}/relatedclients`, {
                ...options,
                params,
            }
        );
    }
}
